import { FAQS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-ng-bg py-24 md:py-36 border-t border-ng-line hex-bg"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 relative z-10">
        <div className="mb-12 max-w-2xl">
          <div className="label-eyebrow mb-5">06 · FAQ</div>
          <h2 className="font-display font-bold uppercase text-4xl md:text-6xl tracking-tight text-white leading-[0.95]">
            Answered <span className="text-ng-blue italic">straight</span>.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-2">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-ng-line bg-ng-surface/60 px-6 md:px-8 data-[state=open]:border-ng-blue/50 data-[state=open]:shadow-[0_0_40px_-15px_rgba(30,144,255,0.5)] transition-all"
            >
              <AccordionTrigger className="font-display font-semibold uppercase tracking-wider text-base md:text-lg text-white hover:text-ng-blue hover:no-underline py-6 [&[data-state=open]>svg]:text-ng-blue text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 font-light leading-relaxed pb-6 text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
